<template>
  <v-autocomplete
    :value="value"
    outlined
    :multiple="multiple"
    :chips="multiple"
    :loading="loading"
    :search-input.sync="search"
    :label="label"
    :hint="hint"
    persistent-hint
    :items="items"
    item-value="id"
    item-text="name"
    hide-details="auto"
    clearable
    hide-no-data
    :cache-items="multiple"
    @input="$emit('input', $event)"
  />
</template>

<script>
import _ from "lodash";

export default {
  props: {
    value: {
      type: Array,
      required: false,
    },
    initialTeachers: {
      type: Array,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: "Select Teacher",
    },
    hint: {
      type: String,
      required: false,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      teachers: [],
      search: null,
      debouncedUpdateTeachers: null,
    };
  },
  watch: {
    search(value) {
      if (value == null || value === "" || value?.length < 2) return;
      this.debouncedUpdateTeachers();
    },
  },
  created() {
    this.debouncedUpdateTeachers = _.debounce(this.updateTeachers, 300);
    this.loadInitialTeachers();
  },
  computed: {
    items() {
      return this.teachers.map(teacher => ({
        id: teacher.id,
        name: `${teacher.firstName} ${teacher.lastName}`,
      }));
    },
  },
  methods: {
    async loadInitialTeachers() {
      if (!this.initialTeachers) return;
      const response = await this.$axios.get("/teacher/get-by-ids", {
        params: { teacherIds: this.initialTeachers.join(",") },
      });
      // add to current teachers
      this.teachers = response.data;
    },
    async updateTeachers() {
      this.loading = true;

      try {
        const response = await this.$axios.get("/teacher", {
          params: {
            "include-all-centers": true,
            searchTerms: this.search,
            size: 50,
          },
        });
        const content = response.data.content;
        this.teachers = content ?? [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
